import React from "react";
import loanstepsrightsideimage from "../assets/loanstepsrightsideimage.png";

const LoanSteps: React.FC = () => {
  const steps = [
    {
      num: "01",
      title: "Apply Online",
      desc: "Fill out a simple form with your basic details.",
      active: false
    },
    {
      num: "02",
      title: "Upload Documents",
      desc: "Securely upload minimal required KYC & income proofs.",
      active: false
    },
    {
      num: "03",
      title: "Get Approved",
      desc: "Instant decision based on our AI evaluation.",
      active: false
    },
    {
      num: "04",
      title: "Receive Funds",
      desc: "Money transferred to your bank account instantly.",
      active: true
    }
  ];

  return (
    <div className="w-full flex flex-col items-center bg-[#EAF1F6]">

      {/* 4 Simple Steps Section */}
      <section id="how-it-works" className="w-full px-6 lg:px-20 font-sans overflow-hidden">
        <div className="max-w-5xl mx-auto flex flex-col gap-12">
          
          {/* Header */}
  <div className="flex flex-col items-end md:items-center gap-2 md:gap-3 text-right md:text-center">
  <h2 className="text-[38px] leading-[42px] sm:text-5xl md:text-[56px] md:leading-[60px] font-black text-[#111827] tracking-[-2px] max-w-[320px] md:max-w-none md:whitespace-nowrap">
    Your Loan in
    <br className="md:hidden" />
    {" "}4 Simple Steps
  </h2>

  <p className="text-[#52525B] font-medium text-sm md:text-lg max-w-[320px] md:max-w-xl">
    A streamlined process designed for speed and simplicity.
  </p>
</div>
          {/* Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            
            {/* Left Column: Timeline Steps */}
            <div className="lg:col-span-6 flex flex-col gap-8 relative pl-4 text-left">
              {/* Timeline Connector Line */}
              <div className="absolute left-[41px] top-6 bottom-6 w-0.5 bg-slate-200 z-0 pointer-events-none" />

              {steps.map((step, idx) => (
                <div key={idx} className="flex items-start gap-6 relative z-10">
                  
                  {/* Step Number Circle */}
                  <div 
                    className={`flex-shrink-0 w-[52px] h-[52px] rounded-full flex items-center justify-center font-bold text-[15px] border transition-all duration-300 ${
                      step.active
                        ? 'bg-[#41A655] border-transparent text-white shadow-[0_4px_12px_rgba(65,166,85,0.25)]'
                        : 'bg-white border-slate-100 text-slate-700 shadow-sm'
                    }`}
                  >
                    {step.num}
                  </div>

                  {/* Step Content */}
                  <div className="flex flex-col gap-1 pt-1.5">
                    <h3 className="text-[14px] font-extrabold text-[#0F172A] tracking-tight leading-none">
                      {step.title}
                    </h3>
                    <p className="text-[11px] text-slate-500 font-medium leading-relaxed">
                      {step.desc}
                    </p>
                  </div>

                </div>
              ))}
            </div>

            {/* Right Column: Illustration Image */}
            <div className="lg:col-span-6 flex justify-end  -mr-12 md:mr-0 md:justify-center items-end relative mt-8 lg:mt-0">
              <div className="relative w-full max-w-[300px] lg:max-w-[440px] flex justify-center items-end">
                <img
                  src={loanstepsrightsideimage}
                  alt="Loan steps guide"
                  className="w-full h-auto object-contain select-none pointer-events-none"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Stats Banner */}
      {/* <section className="w-full bg-[#0B1220] py-12 sm:py-16 px-6 lg:px-20 font-sans relative overflow-hidden">
        <svg className="absolute left-0 top-0 w-32 sm:w-44 h-32 sm:h-44 select-none pointer-events-none z-0" viewBox="0 0 100 100" fill="none" stroke="#41A655" strokeOpacity="0.35" strokeWidth="2">
          <path d="M -10 28 C 10 34, 28 30, 50 18 C 70 8, 88 -2, 110 -16" strokeLinecap="round" />
          <path d="M -10 58 C 18 66, 42 58, 68 42 C 88 30, 102 18, 118 4" strokeLinecap="round" />
        </svg>
        <svg className="absolute right-0 bottom-0 w-32 sm:w-44 h-32 sm:h-44 select-none pointer-events-none z-0" viewBox="0 0 100 100" fill="none" stroke="#41A655" strokeOpacity="0.35" strokeWidth="1.5">
          <path d="M 100,80 A 20,20 0 0 0 80,100" />
          <path d="M 100,65 A 35,35 0 0 0 65,100" />
        </svg>
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-around items-center gap-10 sm:gap-6 relative z-10">
          {[
            { value: "50k+", label: "Customers" },
            { value: "500Cr+", label: "Disbursed" },
            { value: "98%", label: "Approval Satisfaction" }
          ].map((stat, idx) => (
            <div key={idx} className="flex flex-col items-center text-center">
              <span className="text-white text-4xl sm:text-[46px] font-black tracking-tight leading-none">{stat.value}</span>
              <span className="text-[#41A655] font-bold text-sm uppercase tracking-widest mt-3.5">{stat.label}</span>
            </div>
          ))}
        </div>
      </section> */}

    </div>
  );
};

export default LoanSteps;
